var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("print-preview-app-detail-header", {
        attrs: {
          "show-toggle": false,
          "show-print": false,
          "show-back": !_vm.isNewBrowserTab,
        },
        on: { appDetailHeaderButtonClicked: _vm.onHeaderButtonClicked },
      }),
      _c(
        "div",
        {
          style: `height: calc(100vh - ${_vm.toolbarHeight}px); overflow: hidden;`,
          attrs: { id: "pdf-container", name: "pdf-container" },
        },
        [
          _c(
            "object",
            {
              staticClass: "pdf-document",
              attrs: {
                id: "pdfDoc",
                data: _vm.pdfUrl,
                type: "application/pdf",
              },
            },
            [
              _c("embed", {
                staticClass: "pdf-document",
                attrs: { src: _vm.pdfUrl, type: "application/pdf" },
              }),
            ]
          ),
        ]
      ),
      _vm.isExportModalActive
        ? _c("print-preview-export-modal", {
            attrs: { active: _vm.isExportModalActive },
            on: {
              "update:active": function ($event) {
                _vm.isExportModalActive = $event
              },
              exportReport: _vm.exportReport,
              close: _vm.closeExportModal,
            },
          })
        : _vm._e(),
      _vm.isEmailModalActive
        ? _c(
            "vue-email-modal",
            {
              attrs: {
                active: _vm.isEmailModalActive,
                "icon-name": "mdi-email-open",
                "icon-type": "primary",
                "enable-send":
                  _vm.enableSend &&
                  !_vm.isImageAttachActive &&
                  !_vm.isDocAttachActive,
                "enable-attach": _vm.enableAttach,
                "toggle-attach-button":
                  _vm.isImageAttachActive || _vm.isDocAttachActive,
              },
              on: {
                "update:active": function ($event) {
                  _vm.isEmailModalActive = $event
                },
                send: _vm.sendEmail,
                discard: _vm.discardEmail,
                attach: _vm.attachMedia,
                "show-attach": _vm.showAttachImage,
                "attach-docs": _vm.attachDocs,
                "attach-files": _vm.onAttachFiles,
                "done-attach": _vm.doneAttach,
              },
            },
            [
              _c(
                "div",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _vm.isEmailModalActive &&
                  !_vm.isImageAttachActive &&
                  !_vm.isDocAttachActive
                    ? _c("vue-email", {
                        ref: "emailer",
                        attrs: {
                          "report-bytes": _vm.reportBytes,
                          "report-name": `${_vm.emailer.reportName}.${_vm.reportExtension}`,
                          "report-content-type": _vm.reportContentType,
                          "quote-image-attachments": _vm.selectedImages,
                          "quote-attachments": _vm.selectedDocuments,
                          "asset-id": _vm.emailer.assetId,
                        },
                        on: {
                          "new-email": _vm.newEmailInput,
                          sent: _vm.sent,
                          "validation-changed": _vm.handleValidationChanged,
                        },
                        model: {
                          value: _vm.emailer,
                          callback: function ($$v) {
                            _vm.emailer = $$v
                          },
                          expression: "emailer",
                        },
                      })
                    : _vm._e(),
                  _vm.emailer && _vm.isImageAttachActive
                    ? _c("image-select", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isImageAttachActive,
                            expression: "isImageAttachActive",
                          },
                        ],
                        attrs: {
                          "image-select-with-details": true,
                          "quote-id": _vm.emailer.assetId,
                          "quote-ids": _vm.quoteIds,
                        },
                        on: { input: _vm.onImagesSelected },
                        model: {
                          value: _vm.selectedImages,
                          callback: function ($$v) {
                            _vm.selectedImages = $$v
                          },
                          expression: "selectedImages",
                        },
                      })
                    : _vm._e(),
                  _vm.emailer && _vm.isDocAttachActive
                    ? _c("attachment-select", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isDocAttachActive,
                            expression: "isDocAttachActive",
                          },
                        ],
                        attrs: { "quote-id": _vm.emailer.assetId },
                        on: { input: _vm.onDocumentsSelected },
                        model: {
                          value: _vm.selectedDocuments,
                          callback: function ($$v) {
                            _vm.selectedDocuments = $$v
                          },
                          expression: "selectedDocuments",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm.isEmailModalActive && _vm.emailValidation.isAttachmentSizeExceeded
        ? _c("div", { staticClass: "notification is-danger is-light mt-2" }, [
            _vm._m(0),
            _c("span", [_vm._v(_vm._s(_vm.emailValidation.errors.join(" ")))]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-alert" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }